import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Link } from '@mui/material';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, type = 'desktop' }, ref) => {
  // OR using local (public folder)
  // -------------------------------------------------------
  const logo = (
    <Box
      component="img"
      src={type === 'desktop' ? '/assets/transmit-logo.png' : '/assets/sign-png-main.png'}
      sx={{ maxWidth: type === 'desktop' ? 130 : 28, height: 'auto', cursor: 'pointer', ...sx }}
    />
  );

  if (disabledLink) {
    return <Box ref={ref}>{logo}</Box>;
  }

  return (
    <Link ref={ref} to="/" component={RouterLink} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
  type: PropTypes.string,
};

export default Logo;
